const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipientWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.919,
    height: 20,
    viewBox: "0 0 18.919 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13808",
    d: "M233.176 54.122a4.054 4.054 0 1 0 4.054 4.054 4.054 4.054 0 0 0-4.054-4.054zm-5.676 4.054a5.676 5.676 0 1 1 5.676 5.676 5.676 5.676 0 0 1-5.676-5.676z",
    transform: "translate(-223.716 -52.5)",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13809",
    d: "M147.5 271.149h15.593a7.838 7.838 0 0 0-15.592 0zm-1.663.811a9.46 9.46 0 0 1 18.919 0 .811.811 0 0 1-.811.811h-17.3a.811.811 0 0 1-.81-.811z",
    transform: "translate(-145.835 -252.77)",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientWidgetIcon);
export default __webpack_public_path__ + "static/media/recipient-widget-icon.4fe4d3f3d341ba1919ca6b0bfbae152e.svg";
export { ForwardRef as ReactComponent };